'use strict';

angular.module('scrapQcrmApp')
    .controller('LocationModalCtrl', function($scope, dialog, query, locations, Geocoder) {
  $scope.query = query;
  $scope.locations = locations;

  return $scope.close = location => dialog.close(location);
});
